'use strict';

// Declare app level module which depends on filters, and services
var app = angular.module('myApp', [
 'myApp.filters',
 'myApp.services',
 'myApp.directives',
 'myApp.controllers',
 'ngRoute',
 'ngSanitize',
 'ngAnimate',
 'pageslide-directive',
 'angulartics',
 'angulartics.google.analytics'
 ])
.config(function ($analyticsProvider) {
    $analyticsProvider.firstPageview(true); /* Records pages that don't use $state or $route */
    $analyticsProvider.withAutoBase(true);  /* Records full path */
})
.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/splash', {templateUrl: 'partials/screens/splash.html', controller: 'homeCtrl'});
    $routeProvider.when('/select', {templateUrl: 'partials/screens/select.html', controller: 'configureCtrl'});
    $routeProvider.when('/map', {templateUrl: 'partials/screens/map.html', controller: 'appCtrl'});
    $routeProvider.when('/collect', {templateUrl: 'partials/screens/collect.html', controller: 'cartCtrl'});
    $routeProvider.when('/casestudies', {templateUrl: 'partials/screens/case-studies.html', controller: 'casesCtrl'});
    $routeProvider.when('/resources', {templateUrl: 'partials/screens/resources.html', controller: 'resourcesCtrl'});
    $routeProvider.when('/share/:profileName?/:exposureOpacity?/:mapName?/:features?/:hazardOpacity?/:extent?/:basemap?', {templateUrl : 'partials/screens/share.html', controller : 'shareCtrl'});
    $routeProvider.when('/services', {templateUrl : 'partials/screens/services.html', controller : 'servicesCtrl'});
    $routeProvider.when('/howto', {templateUrl : 'partials/screens/how-to.html', controller : 'howtoCtrl'});
    $routeProvider.otherwise({redirectTo: '/splash'});
}]);